import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { HtmlTypography } from 'src/components/HtmlTypography';
import { Icon } from 'src/components/Icon';
import { useOptionalSession } from 'src/contexts/SessionContext';
import { fetchHelloBar } from 'src/models/admin/hello_bar';
import { isAdmin, isTrainer } from 'src/models/user/utils';

export function HelloBar() {
  const [isVisible, setIsVisible] = useState(false);
  const { user } = useOptionalSession();
  const isTrainerOrAdmin = user && (isTrainer(user) || isAdmin(user));
  const { data: helloBar } = useQuery({
    queryKey: ['helloBar'],
    queryFn: fetchHelloBar,
  });

  const smDown = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  useEffect(() => {
    if (!helloBar?.active || !helloBar.message) return;

    const lastSeenAt = localStorage.getItem('helloBarLastSeenAt');
    const shouldShow =
      !lastSeenAt ||
      lastSeenAt < helloBar.updatedAt ||
      !helloBar.updatedAt ||
      helloBar.alwaysShow;
    setIsVisible(shouldShow);
  }, [helloBar]);

  if (
    !helloBar?.active ||
    !helloBar.message ||
    !isVisible ||
    (!isTrainerOrAdmin && !helloBar.alwaysShow)
  ) {
    return null;
  }

  const handleClose = () => {
    localStorage.setItem('helloBarLastSeenAt', helloBar.updatedAt.toString());
    setIsVisible(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        py: 1,
        px: { xs: 2, sm: 6 },
        pr: { xs: 6, sm: 6 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
      }}
    >
      <Box flexGrow={1} textAlign="center">
        <HtmlTypography
          variant="body2"
          textAlign={smDown ? 'left' : 'center'}
          sx={[
            {
              '& a': {
                color: 'inherit',
                textDecoration: 'underline',
              },
              textWrap: 'pretty',
            },
          ]}
        >
          {helloBar.message}
        </HtmlTypography>
      </Box>
      <IconButton
        size="medium"
        onClick={handleClose}
        sx={{ color: 'inherit', position: 'absolute', right: '8px' }}
      >
        <Icon icon={icon({ name: 'close', style: 'regular' })} size="small" />
      </IconButton>
    </Box>
  );
}
